import { usePtlSignupState } from "../../ptlSignup/state";
import { LoginForm } from "../../schoolUiComponents/loginForm";
import React from "react";
import FlexBox from "schoolUiComponents/basic/Box/FlexBox";
import Text from "schoolUiComponents/basic/Text";
import { Colors } from "baseStyles/enums/colors";
import { Banner } from "schoolUiComponents/Banner";
import { interactedLoginViaOtpByClassroomLinkedParentEvent, interactedPtlParentLoginScreenEvent } from "../events";
import { REFERRER_PAGE_MAP } from "utility/referrer";
import PositionBox from "schoolUiComponents/basic/Box/PositionBox";
import { history } from "../history";
import { PageNames } from "../../schoolUiComponents/loginForm/formV2";
import LoginStyles from "./style";

const getParams = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get("token");

    try {
        return token ? JSON.parse(atob(token)) : {};
    } catch (e) {
        console.error(e);
    }
    return {};
}


export const Login = () => {
    const { sendEvent } = usePtlSignupState();
    const styles = LoginStyles();

    const backHandler = () => {
        const referrerPage = REFERRER_PAGE_MAP[params?.referrer_code] || "default";
        const invitationSource = params?.referral_type || "";
        history.goBack();

        // @ts-ignore
        if(window.ptlLoginEventProps?.pageName === PageNames.PTL_LOGIN){
            interactedPtlParentLoginScreenEvent({ clickedOn: "Back button", referrerPage, invitationSource })
        }
        else {
            interactedLoginViaOtpByClassroomLinkedParentEvent({ clickedOn: "Back button", 
                // @ts-ignore
                otpEntered: window.ptlLoginEventProps?.otpEntered, 
                referrerPage, invitationSource 
            })
        }
    }

    const params = getParams();

    return (
        <FlexBox fullWidth center minHeight={`${window.innerHeight - 61}px`} backgroundColor={Colors.WHITE} relative>
            {(history.length > 2)  && <PositionBox.absolute onClick={backHandler} left={34} top={36}><Text.H2 color={Colors.PURE_PURPLE} hoverColor={Colors.NAVY_BLUE}><i style={{fontSize: '18px' }} className="iconcust-iconBackBtn"></i></Text.H2></PositionBox.absolute>}
            <FlexBox className="parent-login" center column gap={24} margin={"32px 0"}>
                <FlexBox gap={8} margin={"0 0 10px 0"} column>
                    <Text.H1 center fontWeight={700}>Log in to continue</Text.H1>
                    {params?.masked_email ? <Banner fullWidth={true}>{params?.user_id ? "Student already linked to below email address" : "Account already exists with entered email address"}</Banner> : null}
                </FlexBox>
                <LoginForm primaryInputLabel="Parent email" source={`PTL Login`} showSocialLogin={false} showV2 />
                {/* <FlexBox gap={8}>
                    <Text.H4 fontWeight={400} color={Colors.CONTENT_TEXT_SECONDARY}>Don’t have an account</Text.H4>
                    <Box onClick={() => {
                        const url = "/parents/register";
                        interactedPtlParentLoginScreenEvent({ clickedOn: "Sign up here", interactionDetails: "", referrerPage: REFERRER_PAGE_MAP[params.get("referrer_code")] || "", invitationSource: params.get("referral_type") || "" });
                        window.location.href=url;
                    }}><Text.H4 noUnderline cta>Sign up here</Text.H4></Box>
                </FlexBox> */}
            </FlexBox>
        </FlexBox>
    );
}